import { useState, useMemo, useEffect } from "react";
import styled from "@emotion/styled";
import {css} from '@emotion/react';
import { useFormData } from "../../../contexts/FormData";

import { useFormikContext } from "formik";

import { BasicFlex, ScrollableContainer, InputLabel, LabelUpper } from "../../../utils/Common";

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

import SimpleChip from "../../../utils/utilities/SimpleChip";
import MultiStatusChip from "../../../utils/utilities/MultiStatusChip";

import { IconButton, lighten, darken, Box, TextField, Checkbox, FormControlLabel, Card, CardContent, CardHeader, Grid, useTheme } from "@mui/material";

import StatBlock from "../../../utils/utilities/StatBlock";

import { formatCurrency } from "../../../utils/util";

const Container = styled.div`
  /* width: 100%; */
  min-width: 40rem;

  @media (${props => props.theme.breaks.down('md')}) {
    min-width: 98%;
  }
`;

const IconBox = styled(BasicFlex)`
  padding: 1rem;
  justify-content: center;
  width: fit-content;
  border-radius: 6px;
  background-color: ${props => lighten(props.theme.colors.secondary, .85)};
  color: ${props => darken(props.theme.colors.secondary, .6)};
`

const VendorName = styled.div`
  font-weight: 600;
  /* color: ${props => props.theme.colors.mildText}; */
`

const Header = ({ vendor }) => {
  return (
    <BasicFlex gap="1.5rem">
      <IconBox>
        <StorefrontOutlinedIcon />
      </IconBox>
      <BasicFlex dir="column">
        <LabelUpper $light $size="1.2rem">Vendor</LabelUpper>
        <VendorName>{vendor}</VendorName>
      </BasicFlex>
    </BasicFlex>
  )
}

const ItemListHeader = () => {
  const theme = useTheme();
  const { values } = useFormikContext() || {};

  let fulfilled = values.accepted_qty + values.stocked_qty || 0;

  return ( 
    <Container>
      <Card variant="outlined" sx={{p: 1, width: "100%"}}>

        <CardHeader sx={{p: 1}} title={<Header vendor={values.vendor_name || "Mollie"} />} action={<MultiStatusChip value={values.shipment_type} values={[{value: "inbound", label: "Consignment", status: "success"}, {value: "outbound", label: "Return", status: "error"}]} />} slotProps={{ action: {sx: {mt: ".2rem"}}}} />

        <CardContent sx={{p: 1, pt: 2, pb: "0 !important"}}>
          <CardBlockContainer>
            <CardBlock header="Received Date" info={values.date_created} dataType="date" spread="12rem" />
            <CardBlock header="Wig Qty" info={values.total_qty} spread="12rem" />
            <CardBlock header="Fulfilled Qty" info={` ${fulfilled} / ${values.total_qty}`} spread="12rem" />
          </CardBlockContainer>
        </CardContent>
      </Card>
      
    </Container>
  ) 
};

export default ItemListHeader;